<template>
  <div class="chat-container w-100 position-relative bg-white pb-5" style="min-height:100vh;">
    <span id="top"></span>
    <Header page="cart"></Header>
    <div class="py-5 px-4">
      <!-- STEPPER -->
      <div class="row pt-3 mb-5">
        <div class="col-12 pt-4">
          <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey py-3 no-ws text-center">
            <template v-for="(menu,index) in stepper">
              <div class="d-inline-block align-top text-center">
                <div class="w-100 mb-2">
                  <div class="be-step-cart mx-auto" :class="{'active':menu.id <= step}">
                    <span class="body-2-4" v-if="menu.id > step || (menu.id == step && index+1 < stepper.length)" :class="{'text-white': menu.id == step }">{{ menu.id }}</span>
                    <div v-else style="line-height: 35px;">
                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.79995 10.9L1.59995 6.7L0.199951 8.1L5.79995 13.7L17.8 1.7L16.4 0.300003L5.79995 10.9Z" fill="#fff"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <p class="mb-0 w-100 text-center mx-auto" :class="menu.id != step ?'body-3-1':'body-3-3-2 text-green'">{{ menu.name }}</p>
              </div>
              <div class="d-inline-block align-top mx-3" style="padding-top: 6px;" v-if="(index+1) < stepper.length">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.74994 20.414L7.33594 19L14.3359 12L7.33594 5L8.74994 3.586L17.1639 12L8.74994 20.414Z" fill="#222"/>
                </svg>
              </div>
            </template>
          </div>
        </div>
      </div>

      <template v-if="!data_parent.show_xendit_cc_form">
        <!-- ORDER DETAIL -->
        <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-3 mb-5">
          <div class="w-100 mb-3 pb-3 border-2-bottom-dashed">
            <p class="mb-0 sub-heading-1-2">Order Summary</p>
            <p class="mb-0 body-2">Visit Date : {{ $formatDate(getTicketCart.visit_date) }}</p>
          </div>
          <div class="w-100 mb-3 border-b-semi-grey">
            <div class="row mb-3 no-gutters" v-for="cart in getTicketCart.ticket_details">
              <div class="col-8">
                <p class="mb-0 body-1-4">{{ cart.ticket.name }}</p>
                <ul class="pl-3">
                  <li v-for="variant in cart.variant">
                    <p class="body-2-1 mb-0">{{variant.data.variant_name}} - {{ $formatCurrency(variant.data.best_price.best_price.final_price) }} x {{ variant.qty }}</p>
                  </li>
                </ul>
              </div>
              <div class="col-4 text-right">
                <p class="text-16 font-lato mb-0">{{ $formatCurrency(printTotalPriceSelected(cart)) }}</p>
                <div class="d-table ml-auto cursor-pointer" @click="removeProductCart(cart)">
                  <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_201_6878)">
                      <path
                        d="M4.41081 12.7934C4.15135 12.7934 3.98503 12.6403 3.97172 12.3875L3.77214 5.06279C3.76549 4.81663 3.93181 4.65696 4.19792 4.65696C4.44407 4.65696 4.61705 4.80998 4.6237 5.05613L4.83659 12.3875C4.84324 12.6337 4.67027 12.7934 4.41081 12.7934ZM6.43994 12.7934C6.18045 12.7934 6.00082 12.6337 6.00082 12.3875V5.06279C6.00082 4.81663 6.18045 4.65696 6.43994 4.65696C6.69939 4.65696 6.88565 4.81663 6.88565 5.06279V12.3875C6.88565 12.6337 6.69939 12.7934 6.43994 12.7934ZM8.47568 12.7934C8.21624 12.7934 8.04326 12.6337 8.0499 12.3875L8.25615 5.06279C8.26279 4.80998 8.43577 4.65696 8.68193 4.65696C8.94801 4.65696 9.11435 4.81663 9.10771 5.06279L8.9081 12.3875C8.89482 12.6403 8.72848 12.7934 8.47568 12.7934ZM3.51934 3.04033H4.57713V1.61663C4.57713 1.23742 4.84324 0.991266 5.24241 0.991266H7.62412C8.02328 0.991266 8.28942 1.23742 8.28942 1.61663V3.04033H9.34717V1.5501C9.34717 0.585447 8.72184 0 7.6973 0H5.16923C4.1447 0 3.51934 0.585447 3.51934 1.5501V3.04033ZM0.49896 3.57256H12.3875C12.6603 3.57256 12.8798 3.33971 12.8798 3.06694C12.8798 2.79418 12.6603 2.56798 12.3875 2.56798H0.49896C0.232848 2.56798 0 2.79418 0 3.06694C0 3.34636 0.232848 3.57256 0.49896 3.57256ZM3.39293 14.8158H9.49358C10.4449 14.8158 11.0836 14.1971 11.1302 13.2457L11.5959 3.43285H1.28399L1.75634 13.2524C1.80291 14.2037 2.42827 14.8158 3.39293 14.8158Z"
                        fill="#DC3545" />
                    </g>
                    <defs>
                      <clipPath id="clip0_201_6878">
                        <rect width="12.8798" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="w-100" id="top-section">
            <div class="row">
              <div class="col-6">
                <p class="mb-0 body-1-4">Total</p>
              </div>
              <div class="col-6 text-right">
                <p class="text-16 font-lato mb-0">{{ $formatCurrency(getTicketTotalPrice) }}</p>
              </div>
            </div>
          </div>
        </div>
  
        <!-- CUSTOMER FORM -->
        <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey mb-5">
          <div class="p-3">
            <div class="w-100 mb-3 pb-3 border-2-bottom-dashed">
              <p class="mb-0 sub-heading-1-2">Contact Detail</p>
              <p class="mb-0 body-2">Please fill in the following data for us to send transaction details.</p>
            </div>
            <div class="p-3 border-semi-grey rounded-6 position-relative mb-5" v-if="!isLoggedIn">
              <div class="w-100 z-index-1029 position-relative">
                <div class="row no-gutters mb-2">
                  <div class="col-3 align-self-center">
                    <svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.7197 23.4622C26.0828 23.4622 30.6089 18.7115 30.6089 12.57C30.6089 6.5416 26.0494 1.95416 20.7197 1.95416C15.39 1.95416 10.8305 6.62643 10.8349 12.6146C10.8394 18.7115 15.3812 23.4622 20.7197 23.4622ZM4.40358 46.2676H36.5789C36.3024 45.675 36.1641 45.042 36.1641 44.3688V35.3786C34.8003 34.2997 33.7874 32.8695 33.1942 31.2659C29.9529 29.2092 25.7191 27.8148 20.7197 27.8148C8.00167 27.8148 0 36.4888 0 42.7956C0 44.9625 1.64828 46.2676 4.40358 46.2676Z" class="fill-primary"/>
                      <path d="M42.4595 18.5428C38.2325 18.5428 34.8879 21.9119 34.8879 26.07C34.8879 29.2144 36.74 31.9443 39.573 33.1029V44.3688C39.573 44.7026 39.7332 44.965 39.9646 45.2233L41.9566 47.2001C42.2302 47.4603 42.6615 47.4894 42.9929 47.1825L46.6416 43.5137C46.9774 43.1936 46.9642 42.7602 46.6326 42.4445L44.5138 40.2877L47.5221 37.3598C47.8133 37.0485 47.7976 36.6019 47.4819 36.2461L44.5868 33.3466C48.0446 31.8738 49.9998 29.2527 49.9998 26.07C49.9998 21.9119 46.6308 18.5428 42.4595 18.5428ZM42.4394 22.2234C43.6853 22.2234 44.7149 23.2685 44.7149 24.4987C44.7149 25.8048 43.6853 26.8342 42.4394 26.8342C41.1824 26.8342 40.1284 25.8048 40.1284 24.4987C40.1284 23.2685 41.1579 22.2234 42.4394 22.2234Z" class="fill-primary"/>
                    </svg>
                  </div>
                  <div class="col-9 align-self-center">
                    <div class="w-85">
                      <p class="mb-1 body-1-4">Login or register to get many benefits</p>
                    </div>
                  </div>
                </div>
                <div class="w-100">
                  <p class="mb-3 body-2-2">Transactions are easier and faster by filling in personal data automatically, and you can view order history easily</p>
                  <div class="w-100">
                    <button class="g-btn g-btn-primary g-btn-sm d-inline-block align-middle mr-3" @click="goToAuthPage('Login')">Login</button>
                    <button class="g-btn g-btn-secondary g-btn-sm d-inline-block align-middle" @click="goToAuthPage('Register')">Register</button>
                  </div>
                </div>
              </div>
              <div class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12" style="top:0;left:0;opacity:0.02"></div>
            </div>
            <div class="w-100 pb-3">
              <div v-if="data_parent.is_load" class="py-4 text-center">
                <loader></loader>
              </div>
              <FormGuestDetail v-else ref="contact_form" viewtype="mobile"></FormGuestDetail>
            </div>
          </div>
          <div v-if="!data_parent.is_load" class="p-3 bg-light-page radius-12" id="mid-section">
            <div class="form-check">
              <input class="form-check-input mt-2" type="radio" id="radio1" value="me" v-model="ticket_owner" />
              <label for="radio1" class="form-check-label body-2-2 text-light-bold mb-2">
                I am the visitor
              </label>
              <br>
              <input class="form-check-input mt-2" type="radio" id="radio2" value="someone" v-model="ticket_owner" @input="toggleVisitorForm()" />
              <label for="radio2" class="form-check-label body-2-2 text-light-bold mb-2">
                I’m Booking for someone else
              </label>
            </div>
          </div>
        </div>
  
        <!-- VISITOR DETAIL -->
        <div v-if="ticket_owner != 'me'" class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey mb-5 p-3">
          <div class="w-100 mb-3 pb-3 border-2-bottom-dashed">
            <p class="mb-0 sub-heading-1-2">Visitor Detail</p>
            <p class="mb-0 body-2" @click="toggleVisitorForm()">{{$t('hotel.visitor-detail.tap-detail')}}</p>
          </div>
          <div class="mb-3 position-relative">
            <div class="cursor-pointer p-3 rounded-6 border-form" @click="toggleVisitorForm()">
              <div class="row">
                <div class="col-12 mb-3">
                  <p class="mb-0 body-3">{{$t('hotel.visitor-detail.full-name')}}</p>
                  <p class="mb-0 body-2-4">{{data_parent.visitor_data.name == '' ? '-' : data_parent.visitor_data.name}}</p>
                </div>
                <div class="col-6">
                  <p class="mb-0 body-3">{{$t('hotel.visitor-detail.phone-number')}}</p>
                  <p class="mb-1 body-2-4">{{data_parent.visitor_data.phone_number == '' ? '-' : data_parent.visitor_data.phone_number}}</p>
                </div>
                <div class="col-6">
                  <p class="mb-0 body-3">{{$t('hotel.visitor-detail.email')}}</p>
                  <p class="mb-1 body-2-4">{{data_parent.visitor_data.email == '' ? '-' : data_parent.visitor_data.email}}</p>
                </div>
              </div>
            </div>
            <p class="mb-0 mt-2 text-danger body-2 text-12 font-regular delay" v-if="!data_parent.validation.visitor">{{$t('hotel.visitor-detail.visitor-information')}}</p>
          </div>
        </div>

        <!-- PRODUCT ADDTIONAL INFORMATION -->
        <div v-if="data_parent.addt_info_ticket.length > 0" class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey mb-5 p-3">
          <div class="w-100 mb-4">
            <p class="mb-0 sub-heading-1-2">Additional data for tickets</p>
            <p class="mb-0 body-2">Some tickets require additional data for the ticket redeem process</p>
          </div>
          <ProductAdditionalForm ref="addt_form" :data="data_parent.addt_info_ticket"></ProductAdditionalForm>
        </div>
  
        <!-- PAYMENT METHOD -->
        <div v-if="data_parent.total_payment > 0" class="w-100 radius-12 bg-white box-shadow-light-aff mb-5 p-3"  :class="data_parent.validation.payment ? 'border-semi-grey' : 'border-danger'">
          <div class="w-100 mb-3 pb-3 border-2-bottom-dashed">
            <p class="mb-0 sub-heading-1-2">Payment Method</p>
            <p class="mb-0 body-2">Please select payment method</p>
          </div>
          <div class="w-100">
            <b-skeleton-wrapper :loading="data_parent.is_load">
              <template #loading>
                <div class="w-100 py-3 radius-6 mb-3 border-secondary-t" v-for="i in 2">
                  <div class="row">
                    <div class="col-10">
                      <div class="pl-3">
                        <b-skeleton width="30%" height="22px" class="mb-2"></b-skeleton>
                        <b-skeleton width="100%" height="18px" class="mb-1"></b-skeleton>
                        <b-skeleton width="70%" height="18px"></b-skeleton>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="pr-3">
                        <b-skeleton width="100%" height="60px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            
              <div class="w-100 py-3 radius-6 mb-3 cursor-pointer" v-for="(pm, index) in data_parent.payment_method" :class="pm.id == payment_method_selected.id ? 'border-primary-t bg-light-primary-ticket' : 'border-secondary-t'">
                <div class="row no-gutters" @click="selectPayment(pm)">
                  <div class="col-md-1 col-2 align-self-start">
                    <div class="radio-ticket mx-auto d-table">
                      <div class="active" v-if="pm.id == payment_method_selected.id"></div>
                    </div>
                  </div>
                  <div class="col-md-9 col-8 align-self-start">
                    <div class="px-md-3 pl-0">
                      <p class="mb-0 body-2-4 text-ticket">{{ pm.name }}</p>
                      <!-- <p class="mb-0 body-3-3-1 html-desc text-truncate-inside" v-if="pm.id != payment_method_selected.id"
                        style="height: 21px;overflow:hidden" v-html="pm.description"></p>
                      <p class="mb-0 body-3-3-1" v-else v-html="pm.description"></p> -->
                      <p class="mb-0 body-3-3-1" :class="pm.id == payment_method_selected.id? '' : 'text-truncate-2'" v-html="pm.description"></p>
                    </div>
                  </div>
                  <div class="col-md-2 col-2 align-self-start">
                    <div class="pr-3">
                      <img :src="pm.image_url" style="max-width: 100%;height: 52px;object-fit:contain;">
                    </div>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </div>
          <p class="mb-0 ml-3 mt-2 text-danger body-2 text-12 font-regular delay" v-if="!data_parent.validation.payment">Please select payment method</p>
        </div>
  
        <!-- PRICE DETAIL -->
        <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-3" id="bottom-section">
          <div class="w-100 mb-3 pb-3 border-2-bottom-dashed">
            <p class="mb-0 sub-heading-1-2">Price Detail</p>
          </div>
          <div class="w-100">
            <div class="row mb-3">
              <div class="col-6">
                <p class="mb-0 body-2-4">Subtotal</p>
              </div>
              <div class="col-6 text-right">
                <p class="text-14 font-lato mb-0">{{ $formatCurrency(getTicketSubTotalPrice) }}</p>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <p class="mb-0 body-2-4">Discount</p>
              </div>
              <div class="col-6 text-right">
                <p class="text-14 font-lato mb-0" :class="{
                  'text-green': getTicketDiscountPrice > 0
                }">{{getTicketDiscountPrice > 0? '-' : ''}}{{ $formatCurrency(getTicketDiscountPrice) }}</p>
              </div>
            </div>
            <div class="row mb-3" v-if="data_parent.payment_surcharge > 0">
              <div class="col-6">
                <p class="mb-0 body-2-4">Payment Surcharge</p>
              </div>
              <div class="col-6 text-right">
                <p class="text-14 font-lato mb-0">{{ $formatCurrency(data_parent.payment_surcharge) }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p class="mb-0 sub-heading-1-2">Total</p>
              </div>
              <div class="col-6 text-right">
                <p class="text-18 font-lato mb-0">{{ $formatCurrency(data_parent.total_payment) }}</p>
              </div>
            </div>
          </div>
        </div>
        <block :height="80" />
  
        <div v-if="data_parent.validation.push != ''" class="w-100 mb-5">
          <ErrorMessage :message="data_parent.validation.push" />
        </div>
        <div class="w-100 p-4 bg-white z-index-1040 position-fixed border-t-semi-grey" style="bottom:0;left:0;right:0;">
          <div class="mb-3 w-100 no-ws">
            <div @click="toggleTermsConditions()" class="checkbox-button text-center lh-1 d-inline-block align-top mr-3" :class="data_parent.terms_and_conditions?'active':''">
              <svg style="margin-top: 3px;" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.62233 8.65556L1.3271 5.36034L0.204987 6.47455L4.62233 10.8919L14.105 1.40923L12.9908 0.295013L4.62233 8.65556Z" fill="white"/>
              </svg>
            </div>
            <p class="mb-0 body-2 d-inline-block align-top w-85"><span @click="toggleTermsConditions()">I have read and accepted the</span> <span class="text-green cursor-pointer" @click="toggleTermsConditions(true)">Terms & Conditions</span></p>
          </div>
          <state-button variant="secondary" size="lg" block :click="submitFormTicket" :disabled="!data_parent.terms_and_conditions">Book Now</state-button>
        </div>
      </template>
      <template v-else>
        <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey">
          <XenditInputCC
            :tx_payment="data_parent.tx_payment"
            module_page="TICKET"
            @done="clearCart"
            @expired="goListPage">
          </XenditInputCC>
        </div>
      </template>
    </div>

    <!-- VISITOR FORM -->
    <popup-detail 
      id_ref="visitor_form"
      title="Visitor contact detail"
      direction="bottom" 
      :show="visitor_form_show"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleVisitorForm">
      <template v-slot:body>
        <div class="px-4" :key="visitor_form_key">
          <FormGuestDetail ref="contact_visitor_form" guest_type="someone" viewtype="mobile"></FormGuestDetail>
        </div>
      </template>
      <template v-slot:footer>
	    	<div class="p-4">
		    	<state-button variant="primary" size="lg" block :click="saveVisitorForm">
            Save
          </state-button>
				</div>
	    </template>
    </popup-detail>
  </div>
</template>

<script>
  import {mapGetters,mapMutations,mapActions} from 'vuex'
  import {get,post} from '@/services/index.js'
  import FormGuestDetail from '../../components/ticket/FormGuestDetail';
  import Footer from '../../components/ticket/Footer';
  import Header from '../../components/ticket/Header';
  import XenditInputCC from '@/components/hotel/be/XenditInputCC';
  import ProductAdditionalForm from '../../components/ticket/ProductAdditionalForm'
  import moment from 'moment'

  export default {
    props: ['data_parent','submit_form'],
    components:{
      FormGuestDetail,
      Footer,
      XenditInputCC,
      Header,
      ProductAdditionalForm
    },
    data(){
      return{
        stepper:[
          {id: 1, name: 'Select Ticket '},
          {id: 2, name: 'Fill in data'},
          {id: 3, name: 'Payment'}
        ],
        step: 2, 
        ticket_owner: 'me',
        visitor_form_show: false,
        visitor_form_key: 0,
        payment_method_selected:{},
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getTicketCart',
        'isLoggedIn',
        'getTicketSubTotalPrice',
        'getTicketDiscountPrice',
        'getTicketTotalPrice'
      ])
    },
    watch:{
      ticket_owner(){
        this.ticketSetOwnerCart(this.ticket_owner)
      }
    },
    mounted(){
      this.$smoothScroll('top')
      if(this.getTicketCart.ticket_details.length > 0){
        this.ticket_owner = this.getTicketCart.ticket_owner
      }
    },
    methods:{
      ...mapMutations(['setActiveRoute','ticketSetPaymentDoku']),
      ...mapActions(['ticketSetOwnerCart','ticketClearItemCart','ticketResetItemCart']),
      toggleVisitorForm(){
        this.visitor_form_show = !this.visitor_form_show
        if(this.visitor_form_show){
          this.visitor_form_key++
        }
      },
      goToAuthPage(page){
        this.setActiveRoute(`cart`)
        this.$router.push({
          name: page,
          params: {
            merchant_code: this.getMerchant.code
          } 
        })
      },
      saveVisitorForm(){
        return new Promise((success,fail)=>{
          setTimeout(()=>{
            this.$refs.contact_visitor_form.validateForm()
            .then(()=>{
              this.toggleVisitorForm()
              success()
            }).catch(()=>fail())
          },300)
        })
      },
      printTotalPriceSelected(data){
        let total = 0
        data.variant.forEach(item=>{
          total += (item.data.best_price.best_price.final_price*item.qty)
        })
        return total
      },
      removeProductCart(data){
        this.ticketClearItemCart(data.ticket)
      },
      selectPayment(pm){
        this.payment_method_selected = pm
        this.$emit('selectPayment',pm)
      },
      goListPage(){
        this.$router.push({
          path: '/'+this.getMerchant().code
        })
      },
      clearCart(){
        this.ticketResetItemCart("with_date")
      },
      validateCustomer(){
        return new Promise((success,fail)=>{
          this.$refs.contact_form.validateForm()
          .then(()=>success())
          .catch(()=>{
            this.$smoothScroll('top-section')
            fail()
          })
        })
      },
      validateVisitor(){
        return new Promise((success,fail)=>{
          this.$refs.contact_visitor_form.validateForm()
          .then(()=>success())
          .catch(()=>{
            this.$smoothScroll('mid-section')
            fail()
          })
        })
      },
      validateAddtInformation(){
        return new Promise((success,fail)=>{
          this.$refs.addt_form.validateForm()
          .then(res=>success(res))
          .catch(()=>{
            this.$smoothScroll('mid-section')
            fail()
          })
        })
      },
      submitFormTicket(){
        return new Promise((success,fail)=>{
          this.submit_form().catch(()=>this.$smoothScroll('bottom-section')).finally(()=>success())
        })
      },
      toggleTermsConditions(detail=false){
        if(detail) this.$emit('detailTAC')
        else this.$emit('toggleAcceptTAC')
      }
    }
  }
</script>
<style>
  .be-step-cart{
    width: 35px;
    height: 35px;
    background-color: #ececec;
    border-radius: 50%;
    border: 1px solid #9f9f9f;
    text-align: center;
  }
  .be-step-cart > span{
    line-height: 35px !important;
  }
  .be-step-cart.active{
    background-color: var(--merchant-primary-color);
    border: 1px solid var(--merchant-primary-color);
  }
  .svg-primary{
    fill: var(--merchant-primary-color)
  }
</style>


// WEBPACK FOOTER //
// src/pages/ticket/TicketCartMobile.vue